<p-card data-cy="insurance-container">
  <div class="flex align-items-center justify-content-between mb-4">
    <h3 class="my-0">{{ title }}</h3>
    <button
      pButton
      type="button"
      [label]="updateButtonLabel"
      icon="mi-round mi-add-circle-outline"
      class="p-button-text p-button-sm hidden md:flex"
      (click)="showModal()"
      data-cy="change-insurance-button"
      appClickEvent
      eventName="order_wizard_change_insurance"
    ></button>
  </div>
  <app-insurance-details [insurance]="insurance" data-cy="insurance-details"></app-insurance-details>
  <div class="flex md:hidden justify-content-center">
    <button
      pButton
      type="button"
      [label]="updateButtonLabel"
      icon="mi-round mi-add-circle-outline"
      class="p-button-text p-button-sm mt-3"
      (click)="showModal()"
      data-cy="change-insurance-button"
      appClickEvent
      eventName="order_wizard_change_insurance"
    ></button>
  </div>
</p-card>

<app-insurance-form
  [title]="formTitle"
  [initialValues]="userData"
  [submitHandler]="onSubmit"
  [(visible)]="displayModal"
>
</app-insurance-form>
